<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.code-solid"></svg-vue>
          <h1 class="content-title">
            {{ $t('Embed code') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-purple" to="/admin/settings">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <div class="px-4 py-5 bg-white sm:p-6">
          <template>
            <div class="bg-red-200 rounded-md border-l-4 border-red-500 mb-3 text-red-700 p-4" role="alert">
              <p class="font-bold">{{ 'Attention' }}</p>
              <p class="form-description-text">
                {{ $t('You can toggle default repair portfolio,') }}
                <router-link class="text-sm text-blue-500 hover:text-blue-600" to="/admin/settings/general">{{
                  $t('go to general setting tab')
                }}</router-link>
              </p>
            </div>
          </template>
          <strong class="form-description-text"
            >{{ $t('Copy embed code and past to your web page or your exiting site.') }}
            {{ $t('You can customize style with style attribute as well according to requirements') }}</strong
          >
          <div class="mt-5 grid grid-cols-3 gap-6 ">
            <div class="col-span-3">
              <label class="form-label" for="embed1">{{ $t('Repair booking embed code') }}</label>
              <div class="pt-1 relative rounded-md shadow-sm">
                <textarea
                  id="embed1"
                  v-model="booking"
                  class="bg-green-200 form-input text-green-700 font-semibold text-sm"
                  :placeholder="$t('Repair booking embed code')"
                ></textarea>
              </div>
            </div>

            <div class="col-span-3">
              <label class="form-label" for="embed4">{{ $t('Repair booking widget 2 embed code') }}</label>
              <div class="pt-1 relative rounded-md shadow-sm">
                <textarea
                  id="embed4"
                  v-model="bookingW2"
                  class="bg-green-200 form-input text-green-700 font-semibold text-sm"
                  :placeholder="$t('Repair booking embed code')"
                ></textarea>
              </div>
            </div>

            <div class="col-span-3">
              <label class="form-label" for="embed3">{{ $t('Repair tracking embed code') }}</label>
              <div class="pt-1 relative rounded-md shadow-sm">
                <textarea
                  id="embed3"
                  v-model="tracking"
                  class="bg-green-200 form-input text-green-700 font-semibold text-sm"
                  :placeholder="$t('Repair tracking embed code')"
                ></textarea>
              </div>
            </div>

            <div class="col-span-3">
              <label class="form-label" for="embed4">{{ $t('Contact us form embed code') }}</label>
              <div class="pt-1 relative rounded-md shadow-sm">
                <textarea
                  id="embed4"
                  v-model="contactUs"
                  class="bg-green-200 form-input text-green-700 font-semibold text-sm"
                  :placeholder="$t('Contact us form embed code')"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'embedded',
  data() {
    return {
      loading: true,
      booking: null,
      bookingW2: null,
      tracking: null,
      contactUs: null,
    };
  },
  computed: {
    stringKey() {
      const d = new Date();
      return 't=' + d.getTime() + '&s=' + d.getSeconds();
    },
    bookLinkW2() {
      return this.$store.state.settings.url + '/repair-booking-embed-w2?' + this.stringKey;
    },
    bookLink() {
      return this.$store.state.settings.url + '/repair-booking-embed?' + this.stringKey;
    },
    trackLink() {
      return this.$store.state.settings.url + '/repair-track-embed?' + this.stringKey;
    },
    contactUsLink() {
      return this.$store.state.settings.url + '/repair-contact-us-embed?' + this.stringKey;
    },
  },
  mounted() {
    this.bookingW2 =
      '<iframe src="' +
      this.bookLinkW2 +
      '" name="iframe_booking_w2" style="border: none; height:700px; width:100%;" title="Repair booking"></iframe>';

    this.booking =
      '<iframe src="' + this.bookLink + '" name="iframe_booking" style="border: none; height:700px; width:100%;" title="Repair booking"></iframe>';
    this.tracking =
      '<iframe src="' + this.trackLink + '" name="iframe_tracking" style="border: none; height:350px; width:100%;" title="Repair tracking"></iframe>';
    this.contactUs =
      '<iframe src="' +
      this.contactUsLink +
      '" name="iframe_contact_us" style="border: none; height:500px; width:100%;" title="Contact us form embed code"></iframe>';
    this.loading = false;
  },
};
</script>
